import { api } from '../../api';

import {
  fetchCarDetailInfo,
  fetchCities,
  fetchProvinces,
  fetchQuestions,
  submitAnswers,
} from './fetchInspection';

export const carDetailApi = api.injectEndpoints({
  endpoints: (build) => ({
    fetchQuestions: fetchQuestions(build),
    submitAnswers: submitAnswers(build),
    getProvinces: fetchProvinces(build),
    getCities: fetchCities(build),
    getCarDetailInfo: fetchCarDetailInfo(build),
  }),
  overrideExisting: false,
});

export const {
  useFetchQuestionsQuery,
  useSubmitAnswersMutation,
  useGetProvincesQuery,
  useLazyGetCitiesQuery,
  useGetCarDetailInfoQuery,
} = carDetailApi;
